const isPastOrToday = (dateStr?: string): boolean => {
  if (!dateStr || dateStr === "Other") return false;

  const date = new Date(dateStr);
  if (Number.isNaN(date.getTime())) return false;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  date.setHours(0, 0, 0, 0);
  return date <= today;
};

const getMoveInTitleLabel = (t: any, moveInDate?: string): string =>
  isPastOrToday(moveInDate)
    ? t("bookform.formlayout.accomodationdetails.availablefrom")
    : t("bookform.formlayout.accomodationdetails.movein");

export default getMoveInTitleLabel;
